import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useMember({ id }) {
  const [member, setMember] = useState([]);

  useEffect(() => {
    axios
      .get(routes.api.members.show(id))
      .then((response) => {
        setMember(response.data.data);
      });
  }, [id]);

  return member;
}
